import React, { createContext, useState } from "react";

const ANNONCE_DATE_FIN = new Date("2026-09-15T00:00:00");
const DATE_REPRISE_CONSULTATIONS = new Date("2026-07-03T00:00:00");

const AnnonceContext = createContext();

function AnnonceProvider({ children }) {
  const now = new Date();
  const afficherAnnonce = now < ANNONCE_DATE_FIN;
  const avantConge = now < DATE_REPRISE_CONSULTATIONS;

  const [modaleVue, setModaleVue] = useState(false);

  return (
    <AnnonceContext.Provider
      value={{
        afficherAnnonce,
        avantConge,
        modaleVue,
        setModaleVue,
      }}
    >
      {children}
    </AnnonceContext.Provider>
  );
}

export { AnnonceContext, AnnonceProvider };
